export function formatCanonicalInteger(
  value: string | number | bigint | null,
  locale = 'pt-BR',
): string {
  if (value === null) return 'Indisponível';
  const integer = BigInt(value);
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
    useGrouping: true,
  }).format(integer);
}

export function formatCanonicalCost(
  amount: string,
  currency: string,
  locale = 'pt-BR',
): string {
  const numeric = Number(amount);
  if (!Number.isFinite(numeric)) return `${amount} ${currency}`;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(numeric);
}

export function formatDurationMs(
  value: number | null,
  locale = 'pt-BR',
): string {
  if (value === null) return 'Indisponível';
  if (value === 0) return '0 s';
  const absolute = Math.abs(value);
  if (absolute < 60_000) {
    return `${formatDecimal(value / 1_000, locale)} s`;
  }
  const sign = value < 0 ? '-' : '';
  const totalSeconds = Math.round(absolute / 1_000);
  const hours = Math.floor(totalSeconds / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [
    hours > 0 ? `${hours} h` : null,
    minutes > 0 ? `${minutes} min` : null,
    seconds > 0 ? `${seconds} s` : null,
  ].filter((part): part is string => part !== null);
  return `${sign}${parts.join(' ')}`;
}

export function formatCockpitDateTime(value: string, locale = 'pt-BR'): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'data indisponível';
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'medium',
  }).format(date);
}

export function formatOptionalCockpitDateTime(
  value: string | null,
  locale = 'pt-BR',
): string {
  return value ? formatCockpitDateTime(value, locale) : 'Não informado';
}

function formatDecimal(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 1,
  }).format(value);
}
